import React from 'react';

import { SkeletonWithoutTabsOrBreadcrumbs } from '@townsquare/griffin-main-header/skeleton';
import Loadable from '@townsquare/loadable';
import type { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { starredRouteDefinition } from '@townsquare/routes/starred';
import { platformStarredFeedResource } from '@townsquare/starred-feed/resource';
import { LoadingState } from '@townsquare/starred-feed/skeleton';

starredRouteDefinition.component = Loadable({
	loader: () => import(/* webpackChunkName: "starred-view" */ './components/StarredView'),
	loading: () => <LoadingState />,
});

starredRouteDefinition.header = Loadable({
	loader: () => import(/* webpackChunkName: "starred-header" */ './components/StarredHeader'),
	loading: SkeletonWithoutTabsOrBreadcrumbs,
});

starredRouteDefinition.resources = [platformStarredFeedResource];

export const starredRoute: GlobalHomePageRoute = starredRouteDefinition;
